import WalkThrough from './modules/WalkThrough';

export default {
  WalkThrough,
};
